import React, { useEffect, useState } from "react";
import TicketsHeader from "../../Components/Tickets/TicketsHeader";
import TicketList from "../../Components/Tickets/TicketList";
import { Input, Segmented, Select, Tabs } from "antd";
import Kaliy from "./firms/Kaliy/Kaliy";
import Chirchiq from "./firms/Chirchiq/Chirchiq";
import Ammafos from "./firms/Ammafos/Ammafos";
import { CiSearch } from "react-icons/ci";
import { TicketsStore } from "../../Stores/Tickets/TicketsStore";

export default function Tickets() {
  let [pageChanges, setPageChanged] = useState(
    localStorage.getItem("ticket_key") ? localStorage.getItem("ticket_key") : 1
  );
  const getData = TicketsStore((state) => state.getData);
  const onChange = (value) => {
    if (value == "Max-Chirchiq") {
      localStorage.setItem("ticket_key", 1);
      setPageChanged(1);
    }
    if (value == "Olmaliq") {
      localStorage.setItem("ticket_key", 2);
      setPageChanged(2);
    }
    if (value == "Kaliy") {
      localStorage.setItem("ticket_key", 3);
      setPageChanged(3);
    }
  };

  useEffect(() => {
    let key = localStorage.getItem("ticket_key");
    if (key) {
      setPageChanged(Number(key));
    }
  }, []);

  const items = [
    {
      key: "1",
      label: "Max-Chirchiq",
      children: <></>,
      childrens: <Chirchiq />,
    },
    {
      key: "2",
      label: "Olmaliq",
      children: <></>,
      childrens: <Ammafos />,
    },
    {
      key: "3",
      label: "Kaliy",
      children: <></>,
      childrens: <Kaliy />,
    },
  ];

  return (
    <div>
      <TicketsHeader />

      <div className=" pb-[70px] m-auto">
        <div className="max-w-[900px]  m-auto flex flex-col gap-2">
          {/* <Tabs
            defaultActiveKey={3}
            className="text-[10px] m-0"
            items={items}
            onChange={onChange}
          /> */}
          <Segmented
            size="large"
            options={["Max-Chirchiq", "Olmaliq", "Kaliy"]}
            defaultValue={items[pageChanges - 1].label}
            onChange={(value) => {
              onChange(value);
            }}
          />
          <div className="flex flex-row items-center justify-between gap-2">
            <Input
              prefix={<CiSearch className="text-[16px]" />}
              type="search"
              placeholder="Qidirish"
            />
            <Select
              defaultValue="50"
              style={{ width: 120 }}
              onChange={(e) => {
                getData("product=Аммофос&offset=0&limit=" + e);
                console.log(e);
              }}
              options={[
                { value: "100", label: "100" },
                { value: "400", label: "400" },
                { value: "1000", label: "1 000" },
                { value: "10000", label: "10 000" },
                { value: "disabled", label: "More...", disabled: true },
              ]}
            />
          </div>
        </div>
        <div className="max-w-[1200px] m-auto">
          {items[pageChanges - 1].childrens}
        </div>
      </div>
    </div>
  );
}
